import { IconProps } from "../../utils/global-types/global-types";

const DialerDotsIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_6951_1427)">
        <path
          d="M2.80201 5.10403C4.07338 5.10403 5.10403 4.07338 5.10403 2.80201C5.10403 1.53065 4.07338 0.5 2.80201 0.5C1.53065 0.5 0.5 1.53065 0.5 2.80201C0.5 4.07338 1.53065 5.10403 2.80201 5.10403Z"
          fill="currentColor"
        />
        <path
          d="M9.00123 0.5C7.72984 0.5 6.69922 1.53062 6.69922 2.80201C6.69922 4.0734 7.72984 5.10403 9.00123 5.10403C10.2717 5.10403 11.3032 4.0734 11.3032 2.80201C11.3032 1.53062 10.2717 0.5 9.00123 0.5Z"
          fill="currentColor"
        />
        <path
          d="M15.1987 0.5C13.9279 0.5 12.8965 1.53062 12.8965 2.80201C12.8965 4.0734 13.9279 5.10403 15.1987 5.10403C16.4692 5.10403 17.5007 4.0734 17.5007 2.80201C17.5007 1.53062 16.4692 0.5 15.1987 0.5Z"
          fill="currentColor"
        />
        <path
          d="M2.80201 11.302C4.07338 11.302 5.10403 10.2714 5.10403 9.00001C5.10403 7.72864 4.07338 6.698 2.80201 6.698C1.53065 6.698 0.5 7.72864 0.5 9.00001C0.5 10.2714 1.53065 11.302 2.80201 11.302Z"
          fill="currentColor"
        />
        <path
          d="M9.00123 6.698C7.72984 6.698 6.69922 7.72862 6.69922 9.00001C6.69922 10.2714 7.72984 11.302 9.00123 11.302C10.2717 11.302 11.3032 10.2714 11.3032 9.00001C11.3032 7.72862 10.2717 6.698 9.00123 6.698Z"
          fill="currentColor"
        />
        <path
          d="M15.1987 6.698C13.9279 6.698 12.8965 7.72862 12.8965 9.00001C12.8965 10.2714 13.9279 11.302 15.1987 11.302C16.4692 11.302 17.5007 10.2714 17.5007 9.00001C17.5007 7.72862 16.4692 6.698 15.1987 6.698Z"
          fill="currentColor"
        />
        <path
          d="M9.00123 12.8958C7.72984 12.8958 6.69922 13.9266 6.69922 15.198C6.69922 16.4692 7.72984 17.5 9.00123 17.5C10.2717 17.5 11.3032 16.4692 11.3032 15.198C11.3032 13.9266 10.2717 12.8958 9.00123 12.8958Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_6951_1427">
          <rect
            width="17"
            height="17"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DialerDotsIcon;
